export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span>DRONE</span>
          <p>ambient soundscapes</p>
        </div>
        
        <div className="footer-links">
          <a href="https://bandcamp.com" target="_blank" rel="noopener noreferrer">
            Bandcamp
          </a>
          <a href="https://soundcloud.com" target="_blank" rel="noopener noreferrer">
            SoundCloud
          </a>
          <a href="mailto:contact@drone.ambient">
            Contact
          </a>
        </div>
        
        <p className="footer-copy">
          © {new Date().getFullYear()} · infinite sound
        </p>
      </div>
    </footer>
  );
}
